(() => {
  if (window.luxePdpBelowReady) return;
  window.luxePdpBelowReady = true;

  function youtubeId(raw) {
    try {
      const url = new URL(raw);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
      const host = url.hostname.toLowerCase();
      const parts = url.pathname.split('/').filter(Boolean);
      let id = null;
      if (host === 'youtu.be') id = parts[0];
      else if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com'].includes(host)) {
        if (parts[0] === 'watch') id = url.searchParams.get('v');
        else if (['embed', 'shorts', 'live'].includes(parts[0])) id = parts[1];
      }
      return id && /^[A-Za-z0-9_-]{11}$/.test(id) ? id : null;
    } catch (_) { return null; }
  }

  function init() {
    document.querySelectorAll('[data-lxp] .lxp-nav').forEach(nav => {
      nav.querySelectorAll('a[href^="#"]').forEach(link => {
        link.hidden = !document.getElementById(link.hash.slice(1));
      });
      nav.hidden = !nav.querySelector('a:not([hidden])');
    });

    document.querySelectorAll('[data-lxp-video]').forEach(holder => {
      if (holder.dataset.ready) return;
      const id = youtubeId(holder.dataset.lxpVideo);
      const button = holder.querySelector('button');
      if (!id || !button) return;
      holder.dataset.ready = 'true';
      button.hidden = false;
      const poster = document.createElement('img');
      poster.className = 'lxp-video-poster';
      poster.alt = '';
      poster.width = 1280;
      poster.height = 720;
      poster.loading = 'lazy';
      poster.decoding = 'async';
      let fallbackUsed = false;
      function fallbackPoster() {
        if (!poster.isConnected) return;
        if (!fallbackUsed) {
          fallbackUsed = true;
          poster.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
        } else {
          poster.remove();
        }
      }
      poster.addEventListener('error', fallbackPoster);
      poster.addEventListener('load', () => {
        if (poster.naturalWidth < 320) fallbackPoster();
      });
      holder.prepend(poster);
      poster.src = 'https://i.ytimg.com/vi/' + id + '/maxresdefault.jpg';
      button.addEventListener('click', () => {
        const frame = document.createElement('iframe');
        frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?rel=0';
        frame.title = 'Product video walkthrough';
        frame.tabIndex = 0;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        holder.replaceChildren(frame);
        frame.focus();
      }, { once: true });
    });

  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => setTimeout(init, 0));
})();